<div class="bg-white shadow-sm hover:border-slate-300 hover:shadow-md transition-all relative">
  <div class="p-4">
    <div class="grid grid-cols-2 gap-2 pb-2">
      <h5 class="mb-2 text-slate-200 text-xl font-semibold">
        <mat-icon class="align-top">local_shipping</mat-icon>
        Average Turn Rate
      </h5>
      <span class="flex justify-end">
        <sa-carrier-selector class="pr-1"></sa-carrier-selector>
        <sa-timeframe-selector
          [timeframes]="[30, 60, 90, 120]"
          [default]="timeframe"
          (newItemEvent)="onTimeframeChange($event)"
        ></sa-timeframe-selector>
      </span>
    </div>

    <div class="relative w-full h-[300px]">
      <div
        *ngIf="loading"
        class="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-opacity-70 bg-white"
      >
        <mat-spinner diameter="40"></mat-spinner>
      </div>

      <canvas
        baseChart
        [chartType]="'line'"
        [legend]="true"
        [datasets]="datasets?.datasets"
        [labels]="datasets?.labels"
        [options]="options"
        [colors]="chartColors"
        class="z-10"
        [style.opacity]="loading ? 0.5 : 1"
      >
      </canvas>

      <div
        *ngIf="isNoDataSubject$$ | async"
        class="absolute top-0 left-0 w-full h-full flex items-center justify-center"
      >
        No data
      </div>
    </div>
  </div>
</div>
